import React, { Component } from 'react';
import {Link} from "react-router-dom";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {toggleDarkMode} from "../../actions/preferenceActions";

class ContactInformation extends Component {
    render() {
        let { _preferences: preferences } = this.props;

        return (
            <>
                {/* Start Contact Area */}
                <section className="contact-area section-gap">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="contact-title">
                                    <h2>Me Contacter</h2>
                                    <p>Vous pouvez me contacter grâce aux informations ci-dessous !</p>
                                </div>
                            </div>
                        </div>

                        <div className="row mt-80">
                            <div className="col-lg-4 col-md-4">
                                <div className="contact-box">
                                    <h4>{ preferences._tel }</h4>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-4">
                                <div className="contact-box">
                                    <h4>{ preferences._email }</h4>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-4">
                                <div className="contact-box">
                                    <h4>
                                        <Link to="/contact">
                                            {preferences._address.address}
                                        </Link>
                                    </h4>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-lg-12 text-center">
                                <Link to="/contact" className="primary-btn mt-50" data-text="Contact">
                                    { "Contact".split("").map((rows, keys) => <span key={ keys }>{ rows }</span>) }
                                </Link>
                            </div>
                        </div>
                    </div>
                </section>
                {/* End Contact Area */}
            </>
        );
    }
}

ContactInformation.protoType = {
    _preferences: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    _preferences: state._preferences
});

export default connect(
  mapStateToProps,
  { toggleDarkMode }
)(ContactInformation);